module.exports = __webpack_public_path__ + "static/media/image_dart.77a7bc56.svg";